import LayoutWithSidebar from "../components/LayoutWithSidebar";
import AdminSettingsSideMenu from "../components/AdminSettingsSideMenu";
import AdminOrganizationsListContainer from "../containers/AdminOrganizationsListContainer";
import MainHeaderContainer from "../containers/MainHeaderContainer";

const AdminOrganizationPage = () => {
  const headerContent = () => {
    return <MainHeaderContainer></MainHeaderContainer>;
  };

  const sidebarContent = () => {
    return <AdminSettingsSideMenu></AdminSettingsSideMenu>;
  };

  const contentPanelContent = () => {
    return <AdminOrganizationsListContainer></AdminOrganizationsListContainer>;
  };

  return (
    <LayoutWithSidebar
      headerContent={headerContent()}
      sidebarContent={sidebarContent()}
      mainPanelContent={contentPanelContent()}
    ></LayoutWithSidebar>
  );
};

export default AdminOrganizationPage;
